import { rc } from "./rc";

export const employee_voice_peerset_observations = {
  rc,
};
